import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { Camera } from 'tabler-icons-react';
import BarcodeScanner from '../../components/BarcodeScanner';
import { compilarPatron } from '../../components/BarcodeScanner/serieMatcher';

// Patrón de validación del VIN/serie, configurable por cliente (vacío =
// acepta cualquier código). Se compila una sola vez a nivel de módulo.
const PATRON_SERIE = compilarPatron(process.env.REACT_APP_CALIDAD_SERIE_PATTERN);

// Beep corto vía WebAudio: confirma la lectura sin necesitar un asset de
// audio. Silencioso si el navegador no soporta AudioContext.
function sonarConfirmacion() {
    try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return;
        const ctx = new Ctx();
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.frequency.value = 880;
        gain.gain.setValueAtTime(0.15, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
        osc.connect(gain).connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + 0.15);
    } catch (e) {
        // Sin audio disponible: la confirmación visual del campo basta.
    }
}

// Campo de Número de Serie/Lote de la cabecera del reporte. Aislado a
// propósito: es el terreno preparado para la lectura de código de barras.
// El escáner se envuelve aquí y llama onChange(codigo, "escaner") sin tocar
// CalidadFormModal — exactamente el contrato que dejó este comentario.
export default function CalidadSerieField({ value, onChange, inputRef, disabled, error, helperText }) {
    const [scannerAbierto, setScannerAbierto] = useState(false);
    const [resaltado, setResaltado] = useState(false);

    const handleChange = (e) => onChange(e.target.value, 'teclado');

    const handleDetectado = (codigo) => {
        onChange(codigo, 'escaner');
        setScannerAbierto(false);
        sonarConfirmacion();
        if (navigator.vibrate) navigator.vibrate(80);
        setResaltado(true);
        setTimeout(() => setResaltado(false), 1200);
    };

    return (
        <>
            <TextField
                label="Número de Serie o Lote"
                value={value}
                onChange={handleChange}
                inputRef={inputRef}
                disabled={disabled}
                error={error}
                helperText={helperText || 'Se aplicará a todas las líneas del reporte'}
                fullWidth
                inputProps={{ maxLength: 100 }}
                className={`calidad-serie-field${resaltado ? ' calidad-serie-field--leido' : ''}`}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                disabled={disabled}
                                onClick={() => setScannerAbierto(true)}
                                aria-label="Escanear número de serie"
                            >
                                <Camera size={20} strokeWidth={2} />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <BarcodeScanner
                open={scannerAbierto}
                onClose={() => setScannerAbierto(false)}
                onDetectado={handleDetectado}
                patron={PATRON_SERIE}
                titulo="Escanear número de serie"
                ayuda="Apunta la cámara al código de barras del VIN en el sticker."
            />
        </>
    );
}
